// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item {
  display: flex;
  box-sizing: border-box;
  padding: 15px;
  width: 100%;
  height: 70px;
  vertical-align: top;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  white-space: nowrap;
}

.menu-item.active * {
  color: white;
}

.menu-item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  color: rgba(255, 255, 255, 0.3);
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
}

.menu-item.active .menu-item-icon {
  color: white;
}

.menu-item-icon ion-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
  color: rgba(255, 255, 255, 0.3);
  pointer-events: none;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menu-item-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  line-height: normal;
  font-size: 14px;
  vertical-align: middle;
  margin-left: 15px;
  color: rgba(255, 255, 255, 0.3);
  font-family: Roboto, arial, sans-serif;
  opacity: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  background-color: rgb(74, 74, 74);
}

.menu-divider {
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  width: 100%;
}

.menu-logo {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 45px;
  width: 45px;
  padding: 15px;
}

.menu-logo img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.menu-tab-unread-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: #d92d20;
  border-radius: 50%;
  border: 2px solid rgb(74, 74, 74);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,sCAAsC;EACtC,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;AACtB","sourcesContent":[".menu-item {\n  display: flex;\n  box-sizing: border-box;\n  padding: 15px;\n  width: 100%;\n  height: 70px;\n  vertical-align: top;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.menu-item.active * {\n  color: white;\n}\n\n.menu-item-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 45px;\n  height: 45px;\n  color: rgba(255, 255, 255, 0.3);\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  position: relative;\n}\n\n.menu-item.active .menu-item-icon {\n  color: white;\n}\n\n.menu-item-icon ion-icon {\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n  color: rgba(255, 255, 255, 0.3);\n  pointer-events: none;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.menu-item-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  line-height: normal;\n  font-size: 14px;\n  vertical-align: middle;\n  margin-left: 15px;\n  color: rgba(255, 255, 255, 0.3);\n  font-family: Roboto, arial, sans-serif;\n  opacity: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.menu {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 100%;\n  width: 100%;\n  background-color: rgb(74, 74, 74);\n}\n\n.menu-divider {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.4);\n  width: 100%;\n}\n\n.menu-logo {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 45px;\n  width: 45px;\n  padding: 15px;\n}\n\n.menu-logo img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.menu-tab-unread-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  background-color: #d92d20;\n  border-radius: 50%;\n  border: 2px solid rgb(74, 74, 74);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
